<template>
  <div class="comp-contact">
    <div class="contact-name">CONTACT US:</div>
    <div class="contact flex justify-between items-center">
      <div class="tel-wrapper">
        <div class="c-tel">
          <ProgressiveImage
            img-class="c-tel-icon"
            :src="tel_icon_png"
            :avif="tel_icon_avif"
            :webp="tel_icon_webp"
          />
          <span class="text">{{ contact?.tel }}</span>
        </div>
        <div class="c-tel">
          <ProgressiveImage
            img-class="c-tel-icon"
            :src="email_icon_png"
            :avif="email_icon_avif"
            :webp="email_icon_webp"
          />
          <span class="text">{{ contact?.email }}</span>
        </div>
      </div>

      <BookRequestComponent :house-id="houseId">
        <div class="btn">Request</div>
      </BookRequestComponent>
    </div>
  </div>
</template>

<script>
import BookRequestComponent from '@comps/BookRequestComponent.vue';
import * as allIcons from '@assets/images/icon';

export default {
  components: {
    BookRequestComponent,
  },
  props: {
    houseId: {
      type: Number,
      reuqired: true,
    },
  },
  data() {
    return {
      tel_icon_png: allIcons.telIcon,
      tel_icon_avif: allIcons.telIconAvif,
      tel_icon_webp: allIcons.telIconWebp,
      email_icon_png: allIcons.emailIcon,
      email_icon_avif: allIcons.emailIconAvif,
      email_icon_webp: allIcons.emailIconWebp,
    };
  },
  computed: {
    contact() {
      return this.$store.getters.contact;
    },
  },
};
</script>

<style lang="scss" scoped>
.comp-contact {
  .contact {
    border-radius: 0.5rem;
    background: url('../assets/images/setting/contact-bg.jpg') center/cover;
  }

  .contact-name {
    font-size: 0.9rem;
    line-height: 2rem;
    color: #2b4eb3;
  }

  .contact {
    width: 17.4rem;
    height: 5.25rem;
    color: #fff;
    padding: 0.5rem;
    font-size: 0.8rem;
    font-family: PuHuiTiLight;
  }
}
.tel-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 0.5rem;
}
.c-tel {
  padding: 0 0.6rem;
  height: 1.6rem;
  width: max-content;
  border-radius: 1rem;
  background: rgba(15, 29, 61, 0.2);

  display: flex;
  align-items: center;

  .text {
    font-family: PuHuiTiLight;
  }

  ::v-deep .c-tel-icon {
    width: 1.35rem;
    height: 1.35rem;
    margin-right: 0.3rem;
  }
}
.btn {
  padding: 0.2rem 0.6rem;
  height: 100%;
  color: var(--c-secondary);
  border: 1px solid var(--c-secondary);
  border-radius: 1rem;
  line-height: 4;
  background: rgba(0, 0, 0, 0.2);
  transition: all 0.2s;
  cursor: pointer;
  font-family: PuHuiTiLight;
  font-weight: 800;
}

.btn:hover {
  background: var(--c-primary);
  // background: var(--c-secondary);
  border-color: var(--c-primary);
  color: #fff;
  // color: var(--c-text);
  // text-transform: uppercase;
}
</style>
